import React from "react";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import PillButton from "./PillButton";

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
    }),
};

export default function Hero() {
    return (
        <section
            id="hero"
            className="relative pt-40 md:pt-52 pb-24 md:pb-32 bg-[#F7F7F5] overflow-hidden"
            data-testid="hero-section"
        >
<div
                aria-hidden
                className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[1200px] h-[700px] rounded-full pointer-events-none"
                style={{ background: "radial-gradient(closest-side, rgba(43,123,228,0.18), transparent 70%)" }}
            />

            <div className="relative max-w-6xl mx-auto px-4 md:px-8 text-center">
                <motion.h1
                    initial="hidden"
                    animate="show"
                    variants={fadeUp}
                    custom={0}
                    className="font-display font-black tracking-tighter text-balance"
                    style={{ fontSize: "clamp(56px, 11vw, 120px)", lineHeight: 0.95 }}
                    data-testid="hero-h1"
                >
                    <span className="block text-[#2B7BE4]">Agence web</span>
                    <span className="block text-[#1A2F6E] mt-1 md:mt-2">à Paris</span>
                </motion.h1>

                <motion.p
                    initial="hidden"
                    animate="show"
                    variants={fadeUp}
                    custom={1}
                    className="mx-auto mt-8 max-w-2xl text-base md:text-lg leading-[1.7] text-[#1A1A2E]/70"
                    data-testid="hero-subtitle"
                >
                    L'agence digitale parisienne spécialisée dans la création de sites web pour les artisans.
                </motion.p>

                <motion.div
                    initial="hidden"
                    animate="show"
                    variants={fadeUp}
                    custom={2}
                    className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3"
                >
                    <PillButton
                        as={Link}
                        to="/audit-gratuit"
                        size="lg"
                        variant="primary"
                        data-testid="hero-cta-primary"
                    >
                        Nous contacter
                    </PillButton>
                    <PillButton
                        as={Link}
                        to="/audit-gratuit"
                        size="lg"
                        variant="ghostNight"
                        data-testid="hero-cta-secondary"
                    >
                        Prendre RDV
                        <CalendarDays size={18} />
                    </PillButton>
                </motion.div>
            </div>
        </section>
    );
}
